import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Landing page for /auth/callback?token=...
 * Flask redirects here after Google OAuth completes.
 * Stores the JWT and sends the user to /plus.
 */
export default function AuthCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      localStorage.setItem("ps_token", token);
    }
    // Hard redirect so AuthContext re-initialises with the new token
    window.location.replace("/plus");
  }, [searchParams]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "60vh",
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        Signing you in…
      </Typography>
    </Box>
  );
}
